module.exports = __webpack_public_path__ + "static/img/92060B_C_4_5_20180322_LC.c4e9ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92060B_C_4_5_20180322_LC.png
// module id = 9lMd
// module chunks = 0